import { styled } from '@mui/material';

export const Wrapper = styled('div')(({ theme }) => ({
	padding: '16px',
	overflow: 'auto',

	'& p': {
		margin: 0,
	},

	[theme.breakpoints.down('sm')]: {
		padding: '12px',
	},
}));

export default Wrapper;
